export async function getLocationsRelocationsUseCase(clientId, occupied, relocationRepository) {
    const result = await relocationRepository.get_locations(clientId, occupied);

    const valid = new relocationRepository.model_locations(result.data);
    
    if (!valid.isValid()) {
        throw new Error("Reubicación inválida");
    }
    
    return result.data.data;
}